import { Link } from "react-router-dom";
import { SCHOLAR_ENABLED } from "@/lib/features";
import BrandMark from "@/components/ui/BrandMark";

const columns: { title: string; links: { to: string; label: string }[] }[] = [
  {
    title: "Explore",
    links: [
      { to: "/seerah", label: "Seerah Explorer" },
      { to: "/timeline", label: "World Timeline" },
      { to: "/quran", label: "Quran Companion" },
      { to: "/isnad", label: "Isnad Explorer" },
      { to: "/dhikr", label: "Dhikr Companion" },
    ],
  },
  {
    title: "Learn",
    links: [
      { to: "/clarifier", label: "Misconception Clarifier" },
      { to: "/learning", label: "Learning Paths" },
      { to: "/scholar", label: `Research Assistant${SCHOLAR_ENABLED ? "" : " (coming soon)"}` },
      { to: "/analytics", label: "Analytics" },
      { to: "/bookmarks", label: "Bookmarks" },
      { to: "/settings", label: "Settings" },
    ],
  },
];

const linkClass =
  "text-[15px] text-[var(--color-cream)]/60 hover:text-[var(--color-cream)] transition-colors";

export default function Footer() {
  return (
    <footer className="on-dark relative overflow-hidden bg-[var(--color-night)] text-[var(--color-cream)]/60 border-t border-[var(--color-gold)]/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-8 lg:px-12 pt-20 md:pt-24">
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-x-8 gap-y-12">
          <div className="col-span-2 lg:col-span-4">
            <BrandMark />
            <p className="mt-6 text-[15px] leading-relaxed max-w-[22rem]">
              Authentic Islamic knowledge, verified through chains of narration and scholarly consensus — free, and
              sourced all the way down.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="eyebrow">{col.title}</h4>
              <ul className="mt-6 space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className={linkClass}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="col-span-2 lg:col-span-4">
            <h4 className="eyebrow">Our methodology</h4>
            <p className="mt-6 text-[15px] leading-relaxed max-w-[26rem]">
              Every clarification cites its sources so you can check them, names the scholars behind each
              interpretation, and is reviewed by qualified scholars before it is published.
            </p>
            <ul className="mt-5 flex gap-6">
              <li><Link to="/methodology" className={linkClass}>How we work</Link></li>
              <li><Link to="/corrections" className={linkClass}>Corrections log</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[var(--color-cream)]/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-[13px]">
          <p>© {new Date().getFullYear()} Deen Over Dunya · Built for the Ummah</p>
          <p lang="ar" dir="rtl" className="font-arabic text-[15px] text-[var(--color-gold)]/60">
            بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ
          </p>
        </div>
      </div>

      {/* Wordmark, cropped by the page edge */}
      <p
        aria-hidden="true"
        className="mt-6 -mb-[0.2em] text-center whitespace-nowrap font-display text-[clamp(3.25rem,13.4vw,15rem)] leading-[0.9] tracking-[-0.045em] text-transparent [-webkit-text-stroke:1px_rgba(212,168,83,0.38)] select-none"
      >
        Deen <em className="italic">over</em> Dunya
      </p>
    </footer>
  );
}
